export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-all-700-normal.woff?7d5dc214dee1ac04c932d9be90a62477";